import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { LicenseHolderProps, licenseHolder } from '../constants';
import { AboutContainer, Title } from '../styled';
import {
  LicenseHolderContainer,
  LicenseHolderBox,
  LicenseCount,
  LicenseDesc,
} from './styled';

const LicenseHolderData = ({ name, position, count }: LicenseHolderProps) => (
  <LicenseHolderBox>
    <LicenseCount>
      {/* @ts-expect-error */}
      <Text as="p" size="36px" family="bold" mb="0">
        {count}
      </Text>
    </LicenseCount>
    <LicenseDesc>
      {/* @ts-expect-error */}
      <Text
        as="h3"
        family="bold"
        size="30px"
        color={color.highempahis}
        mb="12px"
      >
        {name}
      </Text>
      <Text as="h5" size="26px">
        {position}
      </Text>
    </LicenseDesc>
  </LicenseHolderBox>
);

const Contact = () => (
  <AboutContainer>
    {/* @ts-expect-error */}
    <Title align="center" mb="80px">
      Pemegang Lisensi
    </Title>
    <LicenseHolderContainer>
      {licenseHolder.map((data) => (
        <LicenseHolderData key={data.count} {...data} />
      ))}
    </LicenseHolderContainer>
  </AboutContainer>
);

export default Contact;
